import { FC, ReactNode } from "react";
import styled from "styled-components";

const StyledDrawerHeader = styled.div`
  padding: 16px 32px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .DrawerHeader__title {
    font-size: 24px;
    line-height: 32px;
  }
`;

interface Props {
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

const DrawerHeader: FC<Props> = ({ actions, className, children }) => {
  return (
    <StyledDrawerHeader className={className}>
      {children && <h2 className="DrawerHeader__title">{children}</h2>}
      {actions}
    </StyledDrawerHeader>
  );
};

export { DrawerHeader };
